/** Who made a change to a work order. */
export enum WorkOrderChangeOrigin {
	USER = 'user',
	WORKFRONT = 'workfront',
	SYSTEM = 'system',
}

/** What gave a work order its PM (`work_order.pm_assigned`). */
export enum PmAssignedBy {
	/** A `region_to_pm` rule, through the Workfront sync. */
	RULE = 'rule',
	/** The parent work order's PM, through the Workfront sync. */
	PARENT = 'parent',
	USER = 'user',
}

/** What the sync does, or would do, to one work order for one bundle version. */
export enum WorkOrderSyncAction {
	CREATE = 'create',
	UPDATE = 'update',
	FLAG_CLOSED = 'flag_closed',
	FLAG_REMOVED = 'flag_removed',
	/** Held by a mapping error: left as it is until it maps cleanly. */
	HOLD = 'hold',
	NONE = 'none',
}

/** Which work order of a bundle an action is about. */
export enum WorkOrderSyncRole {
	PARENT = 'parent',
	CHILD = 'child',
}

/** What the work-order sync does with a mapped bundle version. */
export enum ApplyMode {
	OFF = 'off',
	/** Plan and record each work order's action; write nothing. */
	SHADOW = 'shadow',
	LIVE = 'live',
}

/** Where a refresh from Workfront stands, as the work order page polls it. */
export enum RefreshRunState {
	RUNNING = 'running',
	/** The run found nothing new in Workfront. */
	UNCHANGED = 'unchanged',
	APPLIED = 'applied',
	FAILED = 'failed',
}

/** How one delivery to the sync worker ended. */
export enum SyncSliceOutcome {
	/** The version is applied, recorded, or needs nothing. */
	DONE = 'done',
	/** More work orders remain: a continuation is queued after the last one applied. */
	CONTINUE = 'continue',
	/** Another delivery is applying the bundle: try again shortly. */
	LEASE_BUSY = 'lease_busy',
}

/** The work-order service's step-run processes (ADR-0037). */
export enum WorkOrderStepProcess {
	WORKFRONT_SYNC = 'workfront_sync',
}

/** The work-order service's step-run steps (ADR-0037). */
export enum WorkOrderStep {
	/** One slice of a Workfront bundle version applied to work orders. */
	APPLY = 'apply',
}
